import { render, staticRenderFns } from "./BirthdayModal.vue?vue&type=template&id=5e4d6d54&scoped=true"
import script from "./BirthdayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BirthdayModal.vue?vue&type=style&index=0&id=5e4d6d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d6d54",
  null
  
)

export default component.exports